import Tab from '@mui/material/Tab';
import React from 'react';
import { Link } from 'react-router';
import { tabStyle } from 'src/common/components/AppLayout/AppLayout.styles';
import { TabsContainer } from 'src/common/components/AppLayout/Components/TabsContainer';
import { a11yTabProps } from 'src/common/components/AppLayout/Components/utils';
import { Routes } from 'src/Routes.constants';
import { Actions, Subjects } from 'permissions/ability';
import { useAbility } from 'permissions/hooks/useAbility';
import { usePreviousPath } from 'common/components/AppLayout/AppNavigation/usePreviousPath';
import { useTranslation } from 'react-i18next';
import { useSubscriptionStatusReconciliationAvailable } from 'src/admin/subscriptionStatusReconciliation/hooks/useSubscriptionStatusReconciliationAvailable';

export const AdminTabsLayout = ({
  children,
  additionalTopMargin = 0,
}: {
  children: React.ReactNode;
  firstTabHighlited?: boolean;
  additionalTopMargin?: number;
}) => {
  const previousPath = usePreviousPath();
  const { t } = useTranslation();
  const ability = useAbility();
  const reconciliationAvailable = useSubscriptionStatusReconciliationAvailable();

  return (
    <TabsContainer content={children} additionalTopMargin={additionalTopMargin}>
      {ability.can(Actions.edit, Subjects.customFields) && (
        <Tab
          value={`${Routes.admin}/custom-fields`}
          label={t('customFields.customFields')}
          component={Link}
          to={`${Routes.admin}/custom-fields`}
          state={{ previousPath }}
          sx={tabStyle}
          {...a11yTabProps(t('customFields.customFields'))}
        />
      )}
      {ability.can(Actions.edit, Subjects.importRsims) && (
        <Tab
          value={`${Routes.admin}/rsim-manufacturing-file`}
          label={t('admin.rSimManufacturingFile.rSimManufacturingFile')}
          component={Link}
          to={`${Routes.admin}/rsim-manufacturing-file`}
          state={{ previousPath }}
          sx={tabStyle}
          {...a11yTabProps(t('admin.rSimManufacturingFile.rSimManufacturingFile'))}
        />
      )}
      {reconciliationAvailable && (
        <Tab
          value={Routes.subscriptionStatusReconciliation}
          label={t('admin.subscriptionStatusReconciliation.subscriptionStatusReconciliation')}
          component={Link}
          to={Routes.subscriptionStatusReconciliation}
          state={{ previousPath }}
          sx={tabStyle}
          {...a11yTabProps(t('admin.subscriptionStatusReconciliation.subscriptionStatusReconciliation'))}
        />
      )}
    </TabsContainer>
  );
};
